<template>
  <div>
    <H1>
      ページが見つかりません。
    </H1>

  </div>

</template>

<script>
  export default {
    name: "PageNotFound"
  }
</script>

<style scoped>

</style>
